import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';
import { access_token, info_client, is_show_copy_comment_tooltip } from '../components/stores';
import { location, push } from 'svelte-spa-router';

export const getVideo = (domain, video_url, isAutoplay) => {
  let str = ''

  if (domain === 'vimeo'){
    const arr = video_url.split('')
    const https = arr.splice(0, 8).join('');
    const player = 'player.';
    const vimeo = arr.splice(0, 10).join('');
    const video = 'video/';
    const digit = arr.splice(0, 9).join('');
    const some = '?h=';
    const end = arr.splice(1).join('');
    str = 'https://' + player + vimeo + video + digit + some + end + '&amp';
  } 
  
  if (domain === 'youtu' || domain === 'youtube') {
    let videoId;

    if (domain === 'youtu') {
      videoId = video_url.slice(17);
    }

    if (domain === 'youtube') {
      const secondPart = video_url.split('v=')[1];

      videoId = secondPart 
        ? secondPart.split('&')[0] 
        : video_url.split('live')[1].split('?')[0].substring(1);
    }

    str = `https://www.youtube.com/embed/${videoId}${isAutoplay ? '?autoplay=1&mute=0' : ''}`;
  }

  return str; 
};

export const api = async (
  path,
  method = 'GET',
  body = {},
  isJSON,
  signal
) => {
  const headers = { 
    'Authorization': `Secret ${get(access_token)}`,
  };

  if (isJSON) {
    headers['Content-Type'] = 'application/json; charset=UTF-8';
  }

  const params = {
    method,
    headers,
  }

  if (method === 'POST' || method === 'DELETE' || method === 'PUT') {
    params.body = body;
  }

  if (signal) {
    params.signal = signal
  }

  return await fetch(path, params);
}

export function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export const throttle = (callee, timeout) => {
  let timer = null;

  return function perform(...args) {
    if (timer) {
      return;
    }

    timer = setTimeout(() => {
      callee(...args);

      clearTimeout(timer);
      timer = null;
    }, timeout);
  }
}

export const cutText = (text) => {
  return text.slice(0, 50)
}

export const generateAndCopyCommentLink = async (publicateId, commentTargetId, ordering) => {
  const entity = get(location).split('/')[1];
  const params = `?comment_target_id=${commentTargetId}&ordering=${ordering}`;
  const link = `/${entity}/${publicateId}/${params}`;

  try {
    const toCopy = link || location.href;
    await navigator.clipboard.writeText(`${window.location.origin}/#${toCopy}`);
  } catch (err) {
    console.error('Failed to copy: ', err);
  }

  is_show_copy_comment_tooltip.set(true);

  setTimeout(() => is_show_copy_comment_tooltip.set(false), 3000);
}

export const declination = (number, one, two, five) => {
  if (!number) {
    return `${0} ${five}`;
  }

  if (get(info_client).language === 'en') {
    if (number === 2) {
      return `${number} ${two}`;
    }

    if (number > 2) {
      return `${number} ${five}`;
    }

    return `${number} ${one}`;
  }

  if (Math.floor(number % 100 / 10) === 1) {
    return `${number} ${five}`;
  }

  if (number % 10 === 1) {
    return `${number} ${one}`;
  }

  if (number % 10 > 1 && number % 10 < 5) {
    return `${number} ${two}`;
  }

  return `${number} ${five}`;
};

export const clickOutside = (node) => {
  const handleClick = event => {
    if (node && !node.contains(event.target) && !event.defaultPrevented) {
      node.dispatchEvent(
        new CustomEvent('click_outside', node)
      )
    }
  }

	document.addEventListener('click', handleClick, true);
  
  return {
    destroy() {
      document.removeEventListener('click', handleClick, true);
    }
	}
}

export const scrollToElement = (id, isNeedHighlight = true) => {
  const element = document.getElementById(id);

  if (!element) {
    return;
  }

  const elementRect = element.getBoundingClientRect();
  const absoluteElementTop = elementRect.top + window.pageYOffset;
  const middle = absoluteElementTop - (window.innerHeight / 2);

  window.scrollTo(0, middle);

  if (!isNeedHighlight) {
    return;
  }

  element.firstChild.style.background = "#EFF1FD";

  setTimeout(() => {
    element.firstChild.style.background = "transparent";
  }, 2000);
};

export const getComment = async (id, ordering) => {
  const response = await api(`/api/v1/comment/find/${id}/?parent_page_size=20&ordering=${ordering}`);
  const data = await response.json();

  return data;
}

export const emojis = [
  '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','🫠','😉','😊','😇',
  '🥰','😍','🤩','😘','🥲','😋','😛','😜','🤪','🤗','🫣','🤫','🤔','🫡',
  '🤐','🤨','😐','😑','😏','😒','🙄','😬','😌','😔','😪','🤤','😴','🤢',
  '🤮','🤧','😵','😵‍💫','🤯','🥸','😎','🤓','😕','🫤','😟','🙁','🥺','😦',
  '😰','😢','😭','😣','😩','🥱','😤','😡','👿','💩','👾','🤖','😺','😸',
  '😹','😻','😼','😽','🙀','😿','😾','🙈','🙉','🙊','💖','💓','💯','💥',
  '👋','🤚','🖐','✋','🖖','👌','🤌','🤘','🤙','👈','👉','👆','👇','👍',
  '👎','👏','🙌','🫶','👐','🙏','💪','👀','🥑','🍆','🥦','🍔','🍕'
];

export const goBack = async (isMobileApp, backUrl = '/') => {
  if (isMobileApp && !document.referrer) {
    window.open('pht://navigate?to=back');
  } else {
    push(backUrl);
  }
}